<div class="card" style="position: relative; width: 100%; aspect-ratio: 1 / 1;">
  <div class="matrix-header" style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 0.5rem;">
    <h6 style="margin: 0;">{{ showLowestItems ? 'Lowest Profitables and Sales Matrix' : 'Top Profitables and Sales Matrix' }}</h6>
    <div style="display: flex; align-items: center; gap: 0.5rem;">
      <label for="lowestItemsSwitch" style="font-size: 0.85rem; color: #475569;">Show Lowest</label>
      <p-inputSwitch
        inputId="lowestItemsSwitch"
        [(ngModel)]="showLowestItems"
        (onChange)="onLowestItemsToggle()">
      </p-inputSwitch>
    </div>
  </div>
  <div class="matrix-loading-overlay" *ngIf="isTopItemsLoading">
    <span class="matrix-loader"></span>
    <span class="matrix-loader-text">Loading profitables and sales...</span>
  </div>
  <canvas #chartCanvas [style.opacity]="isTopItemsLoading ? 0.35 : 1"></canvas>
</div>
